module.exports = __webpack_public_path__ + "static/media/15_before.05f83651.jpg";